import styled, { css, keyframes } from 'styled-components';
import { Breakpoints } from '../../../../styled/constants';
import { FlexColumn } from '../../../../styled/common';
import { tagStyles } from '../../../ui/Typography/styles';
import BridgeLink from '../../../../bridge/components/BridgeLink';
import {
  HeaderCloseButton,
  HeaderLeftAction,
  HeaderTitle
} from '../../../ui/PageHeader/styled';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const modalStyles = css`
  border-radius: 14px 14px 0 0;
  padding-bottom: env(safe-area-inset-bottom);
  height: max-content;
  align-self: end;

  @media (min-width: ${Breakpoints.tablet}px) {
    align-self: center;
    height: max-content;
    width: 455px;
    animation: ${fadeIn} 0.4s ease-out forwards;
  }
`;

export const headerStyles = css`
  ${HeaderLeftAction} {
    width: 45px;

    ${HeaderCloseButton} {
      padding: 0;
    }
  }

  @media (min-width: ${Breakpoints.tablet}px) {
    height: 72px;
    padding-left: 30px;

    ${HeaderTitle} {
      ${tagStyles.h2};
    }

    ${HeaderLeftAction} {
      height: 45px;
      right: 15px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
`;

export const LinksContainer = styled(FlexColumn)`
  gap: 10px;
`;

export const ContactsModalContainer = styled(LinksContainer)`
  padding: 20px 30px 30px;

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 20px 30px;
  }
`;

const contactLinkStyles = css`
  display: flex;
  align-items: center;
  gap: 10px;
  color: ${({ theme }) => theme.colors.text.primary};

  &::before {
    content: '';
    display: inline-block;
    width: 30px;
    height: 30px;
    background-position: center;
    background-repeat: no-repeat;
    flex: 0 0 auto;
  }

  @media (hover: hover) {
    &:hover {
      color: ${({ theme }) => theme.colors.systemColors.blue};
    }
  }
`;

export const PhoneLink = styled.a`
  ${contactLinkStyles};
  text-decoration: none;
  ${tagStyles.h9};

  &::before {
    background-image: url('/static/images/residences/brown-phone.svg');
  }
`;

export const ContactEmail = styled.a`
  ${contactLinkStyles};
  ${tagStyles.body_1};
  text-decoration: underline;

  &::before {
    background-image: url('/static/images/residences/mail.svg');
  }
`;

export const ContactWebsite = styled(BridgeLink)`
  ${contactLinkStyles};
  ${tagStyles.body_1};
  text-decoration: underline;

  &::before {
    background-image: url('/static/images/residences/site.svg');
  }
`;
